export { default } from './AuthorizedRoutes'
